<template>
    <div id="main">
        <div id="leftSection">
            <img class="intelligo" src="../assets/Intelligo.png">
            <img class="leftImg" src="../assets/leftImg.png">
        </div>
        <div id="rightSection">
            <div id="header">
                <h1>Buat Akun Terlebih Dahulu!!</h1>
                <h2>Agar mempermudah memantau perkembanganmu</h2>
            </div>
            <div id="form">
                <div id="leftForm">
                    <h3>First Name</h3>
                    <input type="text">
                    <h3>Phone Number</h3>
                    <input type="text">
                    <h3>Password</h3>
                    <input type="password">
                </div>
                <div id="rightForm">
                    <h3>Last Name</h3>
                    <input type="text">
                    <h3>Email</h3>
                    <input type="email">
                    <h3>Ulangi Password</h3>
                    <input type="password">
                </div>
            </div>
            <div id="check">
                <input type="checkbox">
                <p>Simpan Akun</p>
            </div>
            <div id="check" class="check2">
                <input type="checkbox">
                <p>Saya menyetujui semua Ketentuan, Kebijakan Privasi, dan Biaya</p>
            </div>
            <button id="createAccount" value="createAccount">Create Account</button>
            <div id="loginGoogle">
                <img src="../assets/logoGoogle.png">
                <p>Masuk dengan Google</p>
            </div>
            <div id="login">
                <p>Sudah punya akun?</p>
                <a href="#">Log in</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RegisterComp',
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');
#main {
    margin: 0 auto;
    height: 982px;
    display: flex;
    flex-direction: row;
    background-color: #FFFFFF;
    font-family: 'Poppins', sans-serif;
    color: black;
}
#leftSection {
    flex: 50%;
}
#leftSection .intelligo {
    position: absolute;
    margin-top: 35px;
    margin-left: 100px;
}
#leftSection .leftImg {
    width: 603px;
    height: 982px;
    object-fit: cover;
}
#rightSection {
    flex: 60%;
    margin-top: 100px;
    margin-left: 20px;
}
#rightSection #header {
    margin-left: 90px;
}
#header h1 {
    font-size: 32px;
    font-weight: 600;
}
#header h2 {
    font-size: 16px;
    font-weight: 400;
    color: #78839E;
    margin-top: 5px;
    margin-bottom: 5px;
}
#rightSection #form {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
}
#form h3 {
    margin-top: 30px;
    font-size: 14px;
    font-weight: 400;
}
#form input {
    border-radius: 10px;
    width: 300px;
    height: 40px;
    margin-top: 8px;
    padding: 12px 17px;
}
#form #rightForm {
    margin-left: 20px;
}
#check {
    display: flex;
    flex-direction: row;
}
#check p {
    font-size: 12px;
    font-weight: 400;
    margin-left: 10px;
}
#check input {
    width: 18px;
    height: 18px;
    border-radius: 5px;
}
#rightSection button {
    margin-top: 60px;
    width: 400px;
    height: 50px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    border: 1px solid #023047;
    background-color: #023047;
    border-radius: 8px;
}
#rightSection #loginGoogle {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    width: 400px;
    height: 50px;
    font-size: 16px;
    font-weight: 500;
    align-items: center;
    padding: 12px 3px 12px 95px;
    border: 1px solid #DCDCDC;
    border-radius: 8px;
    cursor: pointer;
}
#loginGoogle p {
    padding-top: 17px;
    margin-left: 14px;
}
#rightSection #login {
    display: flex;
    flex-direction: row;
    margin-top: 20px;
}
#login a {
    margin-left: 5px;
    color: #F74D00;
}

@media only screen and (max-width: 500px) {
    #main {
        height: 175px;
    }
    #leftSection {
        flex: 10%;
    }
    #leftSection .intelligo {
        width: 35px;
        height: 7px;
        margin-top: 10px;
        margin-left: 17px;
    }
    #leftSection .leftImg{
        width: 107px;
        height: 175px;
    }
    #rightSection {
        width: 100%;
        margin-top: 10px;
        margin-left: 10px;
    }
    #rightSection #header {
        margin-left: 0;
    }
    #header h1 {
        margin-bottom: 0;
        text-align: center;
        width: 100%;
        font-size: 6px;
    }
    #header h2 {
        margin-top: 3px;
        text-align: center;
        font-size: 5px;
        width: 100%;
    }
    #form h3 {
        margin-top: 3px;
        margin-bottom: -5%;
        font-size: 4px;
        height: 0px;
    }
    #form input {
        border-radius: 5px;
        width: 100%;
        height: 5px;
        margin-top: 0px;
        padding: 3px;
        font-size: 3px;
    }
    #form #leftForm , #form #rightForm {
        width: 45%;
        margin-bottom: -7%;
    }
    #form #rightForm {
        margin-left: 5px;
    }
    #form #rightForm input {
        width: 100%;
    }
    #check {
        height: 10px;
    }
    .check2 {
        margin-bottom: -3%;
    }
    #check input {
        width: 7px;
        height: 7px;
    }
    #check p {
        font-size: 4px;
        margin-left: 3px;
        margin-bottom: 0%;
    }
    #rightSection button {
        margin-top: 0%;
        margin-bottom: 0%;
        width: 40%;
        height: 7%;
        font-size: 6px;
        border: 0px solid #023047;
        border-radius: 3px;
    }
    #rightSection #loginGoogle {
        margin-top: 0;
        width: 40%;
        height: 7%;
        padding: 3px;
        border-radius: 3px;
    }
    #rightSection #loginGoogle img {
        width: 5px;
        height: 5px;
    }
    #rightSection #loginGoogle p {
        font-size: 5px;
        padding-top: 0;
        margin-left: 3px;
        margin-bottom: 0;
    }
    #login p , a {
        font-size: 5px;
        margin-top: -5%;
    }
}
</style>